import React, { useEffect, useState } from 'react'
import CustomImage from '../../components/customImage/customImage'
import useTemplateHook from '../../components/template/templateHook'
import { useTranslation } from 'react-i18next'
import useAxios from 'axios-hooks'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import { useSearchParams } from 'react-router-dom'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import SocialAuth from '../../components/socialAuth'

const EliteEdgeSignUp = (props) => {
  let { isEdit = false, theme, data, setModalState } = props

  const { t } = useTranslation()

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [referralCode, setReferralCode] = useState('')
  const [searchParams] = useSearchParams()
  const code = searchParams.get('referral_code', '')

  const [errorData, setErrorData] = useState({})

  const [hoverState, setHoverState] = useState('')
  // const {} = useContext(AppContext)
  const {
    customNavigate,
    getTemplateImage,
    setLoader,
    setUser,
    LOGIN_API,
    SIGNUP_API,
    EditIcon,
    raiseToast,
  } = useTemplateHook()

  const [{ data: loginRes, loading: loginResLoading }, loginCall] = useAxios(
    {
      url: LOGIN_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: signUpRes, loading: signUpLoading }, signUpCall] = useAxios(
    {
      url: SIGNUP_API,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    if (loginRes && loginRes.success) {
      setUser(loginRes?.data, false, true)
      customNavigate('DIRECT', '/')
    }
  }, [loginRes])

  useEffect(() => {
    if (signUpRes && signUpRes?.success) {
      raiseToast('success', t('register_success_toast'))
      loginCall({
        data: {
          email_id: email,
          password: password,
        },
      })
    }
  }, [signUpRes])

  useEffect(() => {
    setLoader(loginResLoading || signUpLoading)
  }, [loginResLoading, signUpLoading])

  useEffect(() => {
    if (code) {
      setReferralCode(code)
    }
  }, [code])

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const validateInfo = (type) => {
    let isFormValid = true
    let temp = {}

    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = `${t('user_name_empty')}!`
    }
    if (email.trim().length === 0) {
      isFormValid = false
      temp.email = `${t('email_empty')}!`
    }

    if (!email.includes('@') && email.trim().length !== 0) {
      isFormValid = false
      temp.email = `${t('invalid_email')}!`
    }

    if (password !== confirmPassword) {
      isFormValid = false
      temp.confirmPassword = `${t('passwords_match')}!`
    }
    if (password.trim().length === 0) {
      isFormValid = false
      temp.password = `${t('password_empty')}!`
    }
    if (confirmPassword.trim().length === 0) {
      isFormValid = false
      temp.confirmPassword = `${t('password_empty')}!`
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleRegister = async () => {
    if (validateInfo()) {
      signUpCall({
        data: {
          email_id: email,
          password: password,
          name,
          phone,
          referral_code: referralCode,
        },
      })
    }
  }

  const handleChange = (event, func) => {
    const { value, name } = event.target

    if (errorData[`${name}`]) {
      delete errorData[`${name}`]
      setErrorData({ ...errorData })
    }
    func(value)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleModal = (data) => {
    setModalState({ ...data })
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'} relative`}
      onMouseEnter={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <div
          className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-4 right-4 z-10 flex justify-center items-center cursor-pointer"
          onClick={() => handleModal({ modalKey: 'eliteEdgeSignInModal', data: data })}
        >
          <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
        </div>
      )}
      <div
        className="w-full h-full flex justify-center relative xl:pb-10"
        style={{ background: getStyleValue('component_background', 'primary_color', theme.c1) }}
      >
        <div className={`hidden xl:block w-full absolute`}>
          <CustomImage
            imageUrl={getTemplateImage(data.banner_data?.image_s3_key)}
            imgClass="w-full"
            loaderClass="w-full"
            loaderStyle={{
              background: '#5A5A5A50',
            }}
            imgStyle={{ aspectRatio: '1920/451' }}
            imgAlt={'banner_data'}
          />
        </div>
        <div
          style={{ background: getStyleValue('component_background', 'primary_color', theme.c1) }}
          className="w-[80%] xl:w-[700px] z-10 xl:mt-[270px] flex justify-center"
        >
          <div className="flex flex-col items-center xl:w-[500px] mt-10">
            <div
              className={` w-full flex justify-center ${
                isEdit && hoverState === 'IMAGE' && 'component-hover-class'
              } relative`}
              onMouseOver={() => handleHoverItems('IMAGE')}
              onMouseLeave={() => handleHoverItems('TOP')}
            >
              {hoverState === 'IMAGE' && (
                <div
                  className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                  onClick={() =>
                    handleModal({
                      modalKey: 'logoModal',
                      data: data,
                      modalSpecificData: {
                        imgWidth: 105,
                        imgHeight: 100,
                        divWidth: '8.4rem',
                        divHeight: '8rem',
                      },
                    })
                  }
                >
                  <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                </div>
              )}
              <CustomImage
                imageUrl={getTemplateImage(data?.logo)}
                imgClass="w-[82px] xl:w-[105px]"
                loaderClass=""
                imgAlt={'image_s3key'}
              />
            </div>
            <div
              className={`${
                isEdit && hoverState === 'SIGNUP_TEXT' && 'component-hover-class'
              } w-full text-center mt-16 flex flex-col items-center relative`}
              onMouseOver={() => handleHoverItems('SIGNUP_TEXT')}
              onMouseLeave={() => handleHoverItems('TOP')}
            >
              {hoverState === 'SIGNUP_TEXT' && (
                <div
                  className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                  onClick={() =>
                    handleModal({
                      modalKey: 'signupTextModal',
                      data: data,
                      modalSpecificData: {
                        stylesConfigArr: ['signup_heading', 'signup_description'],
                      },
                    })
                  }
                >
                  <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                </div>
              )}
              <p
                style={{
                  color: getStyleValue('signup_heading', 'color', theme.c5),
                  fontFamily: getStyleValue('signup_heading', 'font', ''),
                  textAlign: getStyleValue('signup_heading', 'alignment', ''),
                }}
                className={`${getStyleValue(
                  'signup_heading',
                  'font_format',
                  '',
                )} mb-0 text-xl lg:text-[25px] font-bold`}
              >
                {data.signup_text}
              </p>
              <p
                style={{
                  color: getStyleValue('signup_description', 'color', theme.c3),
                  fontFamily: getStyleValue('signup_description', 'font', ''),
                  textAlign: getStyleValue('signup_description', 'alignment', ''),
                }}
                className={` mb-0 mt-4 text-xs xl:w-[300px] ${getStyleValue(
                  'signup_description',
                  'font_format',
                  '',
                )}`}
              >
                {data.signup_description}
              </p>
            </div>
            <div
              className={`w-full ${
                isEdit && hoverState === 'INPUT' && 'component-hover-class'
              } relative`}
              onMouseOver={() => handleHoverItems('INPUT')}
              onMouseLeave={() => handleHoverItems('TOP')}
            >
              {hoverState === 'INPUT' && (
                <div
                  className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer"
                  onClick={() =>
                    handleModal({
                      modalKey: 'signupInputModal',
                      data: data,
                      modalSpecificData: {
                        stylesConfigArr: ['email_password_input'],
                      },
                    })
                  }
                >
                  <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                </div>
              )}
              <input
                type="text"
                name="name"
                value={name}
                onChange={(e) => handleChange(e, setName)}
                style={{
                  color: getStyleValue('email_password_input', 'text_color', theme.c4),
                  borderBottom: `1px solid ${getStyleValue(
                    'email_password_input',
                    'border_color',
                    theme.c4,
                  )}`,
                  background: getStyleValue(
                    'email_password_input',
                    'background_color',
                    'transparent',
                  ),
                }}
                className=" text-sm lg:text-base block w-full p-1 mt-8 focus:outline-none"
                placeholder={`${data.email_text} *`}
              />
              {errorData?.name && (
                <div className="error-message">
                  <p>{errorData.name}</p>
                </div>
              )}
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => handleChange(e, setEmail)}
                style={{
                  color: getStyleValue('email_password_input', 'text_color', theme.c4),
                  borderBottom: `1px solid ${getStyleValue(
                    'email_password_input',
                    'border_color',
                    theme.c4,
                  )}`,
                  background: getStyleValue(
                    'email_password_input',
                    'background_color',
                    'transparent',
                  ),
                }}
                className=" text-sm lg:text-base block w-full p-1 mt-8 focus:outline-none"
                placeholder={`${data.email_text} *`}
              />
              {errorData?.email && (
                <div className="error-message">
                  <p>{errorData.email}</p>
                </div>
              )}
              <PhoneInput
                country={'us'}
                value={phone}
                enableSearch={true}
                onChange={(phone) => {
                  setPhone(phone)
                }}
                inputStyle={{
                  color: getStyleValue('email_password_input', 'text_color', theme.c4),
                  border: `0.5px solid ${getStyleValue(
                    'email_password_input',
                    'border_color',
                    theme.c4,
                  )}`,
                  background: getStyleValue(
                    'email_password_input',
                    'background_color',
                    'transparent',
                  ),
                  width: '100%',
                }}
              />
              <input
                type="password"
                name="password"
                value={password}
                onChange={(e) => handleChange(e, setPassword)}
                style={{
                  color: getStyleValue('email_password_input', 'text_color', theme.c4),
                  borderBottom: `1px solid ${getStyleValue(
                    'email_password_input',
                    'border_color',
                    theme.c4,
                  )}`,
                  background: getStyleValue(
                    'email_password_input',
                    'background_color',
                    'transparent',
                  ),
                }}
                className=" text-sm lg:text-base block w-full p-1 mt-8 focus:outline-none"
                placeholder={`${data.password_text} *`}
              />
              {errorData?.password && (
                <div className="error-message">
                  <p>{errorData.password}</p>
                </div>
              )}
              <input
                type="password"
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => handleChange(e, setConfirmPassword)}
                style={{
                  color: getStyleValue('email_password_input', 'text_color', theme.c4),
                  borderBottom: `1px solid ${getStyleValue(
                    'email_password_input',
                    'border_color',
                    theme.c4,
                  )}`,
                  background: getStyleValue(
                    'email_password_input',
                    'background_color',
                    'transparent',
                  ),
                }}
                className=" text-sm lg:text-base block w-full p-1 mt-8 focus:outline-none"
                placeholder={`${data.confirm_password_text} *`}
              />
              {errorData?.confirmPassword && (
                <div className="error-message">
                  <p>{errorData.confirmPassword}</p>
                </div>
              )}
              {/* <input
                type="text"
                name="referralCode"
                value={referralCode}
                onChange={(e) => handleChange(e, setReferralCode)}
                style={{
                  color: getStyleValue('email_password_input', 'text_color', theme.c4),
                  borderBottom: `1px solid ${getStyleValue(
                    'email_password_input',
                    'border_color',
                    theme.c4,
                  )}`,
                  background: getStyleValue(
                    'email_password_input',
                    'background_color',
                    'transparent',
                  ),
                }}
                className=" text-sm lg:text-base block w-full p-1 mt-8 focus:outline-none"
                placeholder={`${data.referral_code_text} `}
              /> */}
            </div>

            <div
              className={`mt-10 w-full ${
                isEdit && hoverState === 'BUTTON' && 'component-hover-class'
              } text-center relative`}
              onMouseOver={() => handleHoverItems('BUTTON')}
              onMouseLeave={() => handleHoverItems('TOP')}
            >
              {hoverState === 'BUTTON' && (
                <div
                  className="absolute h-[25px] w-[25px] rounded-full bg-[#2172eb] top-2 right-2 flex justify-center items-center cursor-pointer z-10"
                  onClick={() =>
                    handleModal({
                      modalKey: 'signupButtonModal',
                      data: data,
                      modalSpecificData: {
                        stylesConfigArr: ['signup_button', 'account_text'],
                      },
                    })
                  }
                >
                  <img src={EditIcon} className="w-[15px] h-[15px]" alt="edit icon" />
                </div>
              )}
              <button
                style={{
                  backgroundImage: `linear-gradient(to ${getStyleValue(
                    'signup_button',
                    'gradient',
                    'left',
                  )}, ${getStyleValue('signup_button', 'primary_color', theme.c5)}, ${getStyleValue(
                    'signup_button',
                    'secondary_color',
                    theme.c5,
                  )})`,
                  color: getStyleValue('signup_button', 'color', theme.c1),
                }}
                className="w-full  py-2 rounded  xl:text-lg font-medium focus:outline-none"
                onClick={handleRegister}
              >
                {data.signup_button_text}
              </button>
              <p
                className={`mb-0 mt-8 text-sm lg:text-base ${getStyleValue(
                  'account_text',
                  'font_format',
                  '',
                )}`}
                style={{
                  color: getStyleValue('account_text', 'color', theme.c3),
                  fontFamily: getStyleValue('account_text', 'font', ''),
                  textAlign: getStyleValue('account_text', 'alignment', ''),
                }}
              >
                {data.account_text}{' '}
                <span
                  className="font-semibold cursor-pointer"
                  style={{ color: getStyleValue('account_text', 'register_text_color', theme.c5) }}
                  onClick={() => {
                    customNavigate('DIRECT', '/login')
                  }}
                >
                  {data.signin_text}
                </span>
              </p>
            </div>
            <div className="w-full">
              <SocialAuth
                textColor={getStyleValue('email_password_text', 'color', theme.c4)}
                borderColor={getStyleValue('signup_button', 'primary_color', theme.c5)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTheme(EliteEdgeSignUp)
